module.exports = __webpack_public_path__ + "static/media/组 29.ae247f5f.png";